import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

function Mod2 () {
  let SwiperMod2 = () => {
    return (
      <div className='slider sliderIn'>
        <div className='slider-tab_mod'>
          <Swiper
            spaceBetween={10}
            loop={true}
            slidesPerView={1}
            navigation
            breakpoints={{
              767: { // when window width is >= 767px
                spaceBetween: 10,
                slidesPerView: 2
              }
            }}
          >
            <SwiperSlide>
                <div className='tab-item active'>
                    <img src={require('../../image/mod2/part1_a1.png').default} alt=''/>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='tab-item'>
                    <img src={require('../../image/mod2/part1_a2.png').default} alt='' />
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='tab-item'>
                    <img src={require('../../image/mod2/part1_a3.png').default} alt='' />
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className='tab-item'>
                    <img src={require('../../image/mod2/part1_a4.png').default} alt='' />
                    <a href='https://ibobby.ai.hinet.net/container/caption/Caption0201' target='_blank' rel='noopener noreferrer'>
                        <div className='gourl2'></div>
                    </a>
                </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    )
  }

  return (
    <div className='wrapper'>
      <div className='wrapper'>
        <div id='gotop'></div>
        <div className='kv'>
          <img
            className='pc'
            src={require('../../image/mod2/kv.jpg').default}
            alt=''
          />
          <img
            className='mobile'
            src={require('../../image/mod2/kv_m.png').default}
            alt=''
          />
        </div>
        <div className='menu'>
          <ul>
            <li>
              <a href='#part02' className='url'>
                多元服務
              </a>
            </li>
            <li>
              <a href='#part03' className='url'>
                聲控MOD
              </a>
            </li>
            {/*<li>
              <a href='#part05' className='url'>
                方案內容
              </a>
  </li>*/}
            <li>
              <a href='#part07' className='url'>
                音箱簡介
              </a>
            </li>
          </ul>
        </div>

        <div>
          <a href=' ' name='part02'> </a>
        </div>
        <div className='part part02' id='part02'>
          <div className='content  wow fadeInUp'>
            <div className='p02-text '>
              <img
                className='pc'
                src={require('../../image/mod2/part1_title.png').default}
                alt=''
              />
              <img
                className='mobile'
                src={require('../../image/mod2/part1_title_m.png').default}
                alt=''
              />
            </div>
            <div className='slider slider-tab '>
              <SwiperMod2 />
            </div>
          </div>
        </div>
        <img className='line_mod2' src={require('../../image/mod2/line1.png').default} alt='' />
      </div>
      <div>
        <a href=' ' name='part03'> </a>
      </div>
      <div className='part part03' id='part03'>
        <div className='content'>
          <div className='p03-tit  wow fadeInUp'>
            <img
              src={require('../../image/mod2/part2_title.png').default}
              alt=''
            />
          </div>
          <div className=' wow fadeInUp' data-wow-delay='1s'>
            <div className='table'></div>
            <div className='t1'>
              <table>
                <thead>
                  <tr>
                    <th className='a1 nbl'>屬性</th>
                    <th className='a1'>音箱聲控MOD</th>
                    <th className='a1 nbr'>問句</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan='8' className='a2'>
                      語句
                    </td>
                    <td className='a3'>聲控開關</td>
                    <td className='a4'> i寶貝，我要開/關MOD</td>
                  </tr>
                  <tr>
                    <td className='a3'>聲控選台</td>
                    <td className='a4'>
                      i寶貝，我要看/轉_"504台"、 "民視"、"新聞台"
                    </td>
                  </tr>
                  <tr>
                    <td className='a3'>聲控音量</td>
                    <td className='a4'>i寶貝，幫我把MOD音量 調大/小聲</td>
                  </tr>
                  <tr>
                    <td className='a3'>快速搜尋影片</td>
                    <td className='a4'>i寶貝，我要看哥吉拉</td>
                  </tr>
                  <tr>
                    <td className='a3'>指定收看隊伍賽事</td>
                    <td className='a4'>i寶貝，我要看中華隊</td>
                  </tr>
                  <tr>
                    <td className='a3'>指定收看賽事節目</td>
                    <td className='a4'>i寶貝，我要看桌球</td>
                  </tr>
                  <tr>
                    <td className='a3'>指定收看運動員賽事</td>
                    <td className='a4'>i寶貝，我要看戴資穎</td>
                  </tr>
                  <tr>
                    <td className='a3 nbb'>已訂閱過影片</td>
                    <td className='a4 nbb dr'>i寶貝，我要播放、暫停、結束</td>
                  </tr>
                </tbody>
                <tfoot></tfoot>
              </table>
            </div>
            <div className='txt'>
              ※ 頻道節目表由營運商提供，如有異動以實際播出為準。
              <br />※
              若欲使用聲控遙控器聲控MOD，請按一下「語音鍵」，即可開始說話。
            </div>
            <img
              className='pc'
              src={require('../../image/mod2/part2_a1.png').default}
              alt=''
            />
            <img
              className='mobile'
              src={require('../../image/mod2/part2_a1_m.png').default}
              alt=''
            />
          </div>
        </div>
      </div>
      <div className='part part04' id='part04'>
        <div className='content'>
          <div className='p04-tit'>
            <img
              className='pc'
              src={require('../../image/mod2/part3_title.png').default}
              alt=''
            />
            <img
              className='mobile'
              src={require('../../image/mod2/part3_title_m.png').default}
              alt=''
            />
          </div>
          <div className='txt'>
            1.下載「i寶貝+」APP，手機須開啟「藍牙功能」，後續可快速透過wifi聯網
            設定完成。
            <br />
            2.啟用MOD服務，完成配對，即可聲控MOD。
          </div>
          <div className='p04-text wow fadeInUp' data-wow-delay='1s'>
            <img
              className='pc'
              src={require('../../image/mod2/part3_b.png').default}
              alt=''
            />
            <img
              className='mobile'
              src={require('../../image/mod2/part3_b_m.png').default}
              alt=''
            />
          </div>
        </div>
      </div>
      <div>
        <a href=' ' name='part05'> </a>
      </div>
      {/*<div className='part part04 part05' id='part05'>
        <div className='content'>
          <div className='p04-tit'>
            <img
              className='pc'
              src={require('../../image/mod2/part4_title.png').default}
              alt=''
            />
            <img
              className='mobile'
              src={require('../../image/mod2/part4_title_m.png').default}
              alt=''
            />
          </div>
          <div className='t2'>
            <table>
              <thead>
                <tr>
                  <th className='c1 tt1'>項目</th>
                  <th className='c1' colSpan='2'>
                    MOD聲控遙控器+[入門款]LUCIA mini
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className='c2'>方案內容</td>
                  <td className='c2' colSpan='2'>
                    智慧家庭聲控方案(內建i寶貝智慧聲控服務，月租99元)
                  </td>
                </tr>
                <tr>
                  <td className='c3'>適用對象 </td>
                  <td className='c3' colSpan='2'>
                    凡有HiNet光世代且有MOD客戶
                  </td>
                </tr>
                <tr>
                  <td className='c2'>受理管道 </td>
                  <td className='c2 co' colSpan='2'>
                    中華電信門市限定
                  </td>
                </tr>
                <tr>
                  <td className='c3'>MOD用戶 </td>
                  <td className='c3'>
                    聲控遙控器<span className='d1'>０</span>元
                  </td>
                  <td className='c3'>
                    音箱<span className='d2'>０</span>元
                  </td>
                </tr>
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
        </div>
  </div> */}
      <div>
        <a href=' ' name='part07'> </a>
      </div>
      <div className='part part07' id='part07'>
        <div className='content'>
          <img
            className='pc'
            src={require('../../image/mod2/part4_c.png').default}
            alt=''
          />
          <img
            className='mobile'
            src={require('../../image/mod2/part4_c_m.png').default}
            alt=''
          />
          <a
            href='/container/commodity'
            target='_blank'
            rel='noopener noreferrer'
          >
            <div className='goal3'></div>
          </a>
          <a
            href='https://my.cht.com.tw/ServiceCenter'
            target='_blank'
            rel='noopener noreferrer'
          >
            <div className='goal2'></div>
          </a>
          <a
            href='https://my.cht.com.tw/ServiceCenter'
            target='_blank'
            rel='noopener noreferrer'
          >
            <div className='goal'></div>
          </a>
        </div>
      </div>
      <div className='part part06' id='part06'>
        <div className='content'>
          <div className='p06-tit wow fadeInUp'>貼心小提醒</div>
          <div className='notice_mod wow fadeInUp' data-wow-delay='1s'>
            <div className='notice-title'>備註說明:</div>
            <ul>
              <li>
                中華電信人員到府安裝聲控遙控器，竣工後3個工作天智慧音箱將宅配到府。
              </li>
              <li>
                如申租之MOD服務為一戶多機使用下，本服務僅提供第一機機上盒使用。
              </li>
              <li>
                租用本服務須與特定型號之機上盒及遙控器搭配(其型號及規格請詳閱MOD官網
                <a
                  href='https://mod.cht.com.tw/'
                  target='_blank'
                  rel='noreferrer'
                >
                  https://mod.cht.com.tw/
                </a>
                說明) 。
              </li>
              <li>
                ※其餘詳本案注意事項或i寶貝官網查詢
              </li>
            </ul>

            <div className='notice-title'>本方案注意事項</div>
            <ul>
              <li>
                綁約期限24個月，中途不可轉換至其他優惠方案，綁約期滿後仍以99元優惠價計收。
              </li>
              <li>
                提前解約金計算 :
                綁約期限未到期前，因故提前終止租用，應給付聲控音箱2490元與MOD聲控助理服務300元
                ( 前述解約金按未滿租期比例計收，即 :
                前述解約金*未滿租期日數/租期總日數) 。
              </li>
              <li>
                客戶收到智慧聲控音箱後於7天內，如無法使用或發生故障時，客戶得選擇辦理換或或者終止本優惠方案(含i寶貝聲控服務即聲控助理終止)
                ，請撥打客服專線0800-080-123;
                惟客戶如欲拜理終止本優惠方案，客戶須憑物流廠商前往取件之宅配取件單，才能至中華門市辦理本優惠方案終止，請詳閱i寶貝智慧聲控(ibobby)服務租用契約條款第3條。
              </li>
              <li>
                其他 :
                1.本優惠方案所需之HiNet光世代及MOD等業務之申請、異動、綁約、每月應繳費用、補償金（或解約金）、及終止租用等，皆以前述各項優惠申請書說明為準，應另填前述申請書並遵守各業務之服務條款或相關規定。2.「i寶貝+」APP內其他加值服務（如：
                eHome…等），須另行付費及申請。3.
                MOD聲控助理服務應注意以下事項：（1）係提升MOD遙控器之功能，讓使用者更便利、快速地搜尋MOD平台的內容，不包含第三方加值服務。請詳閱MOD「智慧生活」內「聲控助理」內的使用說明。（2）如MOD申請一戶多機時，本優惠之聲控遙控器僅提供於第一台機上盒使用。（3）此服務須與特定型號之機上盒及遙控器搭配（其型號及規格詳閱MOD
                官網
                <a
                  href='https://mod.cht.com.tw/'
                  target='_blank'
                  rel='noreferrer'
                >
                  https://mod.cht.com.tw/
                </a>
                說明），前述機上盒如有機種更換之情況，本公司得派員替換或者更新。（4）如使用者自行變更其設定或改以Wi-Fi連接至網際網路，可能因網路連線品質不佳，以致影響語音辨識率或者不能使用時，則需要使用者自行檢查連網情況。5.
                MOD看片金使用說明：（1）當申請本優惠方案竣工後，系統將自動為客戶儲值看片金每月$50元，連續贈三個月（2）每月諍訟之看片金需於一個月內（每筆儲值日至下一筆儲值日）使用完畢，當月未使用完之看片金，無法延展至次月使用，客戶可自M
                O
                D平台看片金頁面查詢使用期限。（3）如提前終止本優惠方案或因（七）終止本專案方案時，本看片金立即停止贈送（4）看片金現抵扣單點影片只單片48小時及全年無線看（單片全年）訂閱費用。
              </li>
            </ul>
            <div className='notice-title'>
              ※i寶貝智慧聲控服務(以下簡稱本服務)注意事項:
            </div>
            <ul>
              <li>
                i寶貝聲控服務(以下簡稱本服務)須在無線網路（Wi-Fi）或行動網路熱點分享（
                4G以上）環境下使用，且申請人需自備智慧型手機（Android或iOS作業系統，支援之手機型號詳列於產品網站
                <a href='/' target='_blank' rel='noopener noreferrer'>
                  https://ibobby.ai.hinet.net/
                </a>
                ) ，並下載「i寶貝+」APP進行設定。
              </li>
              <li>
                本服務使用係於「i
                寶貝+」APP登入中華電信會員帳號後，綁定CPE設備（智慧音箱/聲控機器人/智慧型手機）連網後方可使用。
              </li>
              <li>
                本服務需搭配指定之CPE 設備（智慧音箱/聲控機器人），
                CPE設備保固一年。如遇安裝及操作、或新申請新品之換貨、或保固期限內CPE設備故障問題，請撥打客服專線0800-080-123洽詢。
              </li>
              <li>
                本服務僅限於台澎金馬地區使用，實際可提供之廣播、新聞、股票報價、天氣及交通查詢的內容，以中華電信/合作廠商授權之內容與項目為準。且前述資訊查詢內容為合作廠商提供，本公司無法保證其準確性。
              </li>
              <li>
                本服務僅供家中或私人場所使用，不得於公眾場所、營業場所或供營業使用，如有前述情形本公司德暫停、中斷本服務或終止客戶租用，如有違反相關法律責任，由客戶自行負責。
              </li>
              <li>
                為提升本服務使用品質，得對使用者聲控操作之人聲進行紀錄，作為優化本服務之用。
              </li>
              <li>
                本服務僅可使用國語、英語及台語進行語音辨識搜尋，且本服務語音辨識率及結果，亦或可能受使用者使用本服務時之環境是否具有雜音，以及使用者個人之發音、腔調、聲調等個人因素影響。
              </li>
              <li>
                客戶申租本服應合理使用，如有異常大量聲控操作、惡意行為導致本服務系統異常、侵害智慧財產權或違反法律，本公司得暫停、中斷本服務或終止客戶租用。
              </li>
              <li>
                本服務相關說明及其他注意事項詳如產品網站：{' '}
                <a href='/' target='_blank' rel='noopener noreferrer'>
                  https://ibobby.ai.hinet.net/
                </a>{' '}
                。
              </li>
              <li>中華電信保有變更活動之權利。</li>
            </ul>
          </div>
        </div>
        <img className='line_mod2' src={require('../../image/mod2/line2.png').default} alt='' />
        <div className='contact'>
          <a
            href='https://www.cht.com.tw/zh-tw/home/cht/service/call-line'
            className='contact_btn'
            target='_blank'
            rel='noreferrer'
          >
            <span>專人聯絡</span>
          </a>
          <a
            href='https://my.cht.com.tw/ServiceCenter'
            className='contact_btn'
            target='_blank'
            rel='noreferrer'
          >
            <span>服務據點</span>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Mod2